import { WorkingRangeFormErrorJSON } from '../models/working-schedule';

export const formWorkingRangeErrors: WorkingRangeFormErrorJSON = {
    organizationName: [
        {
            code: 'pattern',
            message: 'Only alphanumeric values, spaces and hyphens can be used',
        },
        {
            code: 'required',
            message: 'Required field',
        },
    ],
};
